import { Component, OnInit } from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
    Validators
} from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PASSWORD_LENGTH_LIMIT } from '@zlib/data-access/constants';
import { AuthService } from '@zlib/services/auth.service';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    imports: [
        TranslateModule,
        NzFormModule,
        FormsModule,
        ReactiveFormsModule,
        NzInputModule,
        RouterModule
    ]
})
export class ForgotPasswordComponent implements OnInit {
    validateEmailForm!: UntypedFormGroup;
    validateNewPasswordForm!: UntypedFormGroup;
    newPasswordVisible = false;
    confirmNewPasswordVisible = false;
    environment = environment;
    email: string = '';

    constructor(
        private formBuilder: UntypedFormBuilder,
        private authService: AuthService,
        private translateService: TranslateService
    ) {}

    ngOnInit(): void {
        this.validateEmailForm = this.formBuilder.group({
            userName: [null, [Validators.required]],
            email: [null, [Validators.required, Validators.email]]
        });
        this.validateNewPasswordForm = this.formBuilder.group({
            newPassword: [null, [Validators.required, this.strongPassword]],
            confirmNewPassword: [
                null,
                [Validators.required, this.passwordConfirmValidator]
            ]
        });
    }

    onSubmitEmail(): void {
        if (this.validateEmailForm.valid) {
            const { userName, email }: { userName: string; email: string } =
                this.validateEmailForm.value;
            this.email = email;

            this.authService
                .forgotPassword(userName, email)
                .subscribe(() => {});
        } else {
            this.validateForm(this.validateEmailForm);
        }
    }

    clearNewPassword(): void {
        this.validateNewPasswordForm.reset();
    }

    passwordConfirmValidator = (
        control: UntypedFormControl
    ): { [s: string]: boolean } => {
        if (!control.value) {
            return { required: true };
        } else if (
            control.value !==
            this.validateNewPasswordForm.controls['newPassword'].value
        ) {
            return { confirm: true, error: true };
        }
        return {};
    };

    strongPassword = (
        control: UntypedFormControl
    ): { [s: string]: boolean } => {
        const lengthRequired =
            (control?.value?.length ?? 0) >= PASSWORD_LENGTH_LIMIT;
        if (!control.value) {
            return { required: true };
        } else if (!lengthRequired) {
            return { length: true };
        }
        return {};
    };

    validateForm(formGroup: UntypedFormGroup): void {
        Object.values(formGroup.controls).forEach((control) => {
            if (control.invalid) {
                control.markAsDirty();
                control.updateValueAndValidity({ onlySelf: true });
            }
        });
    }

    translate(translateText: string): string {
        return this.translateService.instant(translateText);
    }
}
